import { Box, Text, Heading, Button } from '@everlywell/ui-kit';
import React from 'react';

export interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  titleMaxWidth?: string;
  description?: string;
  descriptionMaxWidth?: string;
  align?: 'left' | 'center';
  cta?: {
    text: string;
    link: string;
  };
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  eyebrow,
  title,
  titleMaxWidth = '100%',
  descriptionMaxWidth = '600px',
  description,
  align = 'center',
  cta,
}) => (
  <Box
    width="100%"
    margin="0 auto"
    display="flex"
    flexDirection="column"
    alignItems={align === 'left' ? 'flex-start' : 'center'}
    gap="1rem"
    px={['2', '0']}
  >
    <Box
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems={['center', align === 'left' ? 'flex-start' : 'center']}
      gap="0.5rem"
      textAlign={['center', align]}
    >
      <Text color="#28724f" fontSize="1rem" textAlign={['center', align]}>
        {eyebrow}
      </Text>
      <Heading
        maxWidth={['100%', titleMaxWidth, titleMaxWidth]}
        fontFamily="heading"
        fontWeight="semibold"
        textAlign={['center', align]}
        marginRight={['0', align === 'left' ? 'auto' : '0']}
        fontSize={['30px', '44px']}
        lineHeight={['1.25', '1.2']}
      >
        {title}
      </Heading>
    </Box>
    {description && (
      <Text
        maxWidth={descriptionMaxWidth}
        textAlign={['center', align]}
        color="#545454"
        lineHeight="1.5rem"
      >
        {description}
      </Text>
    )}
    {cta && (
      <Button
        width="auto"
        height="52px"
        px="1.4rem"
        bg="#012B3B"
        color="white"
        margin={[align === 'left' ? 'auto' : '0', '0', '0']}
        borderRadius="1.75rem"
        onClick={() => {
          const link = cta.link;
          if (link) {
            document
              .querySelector(link)
              ?.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        fontSize={['15px', '16px']}
        fontWeight="500"
        _hover={{
          backgroundColor: '#012B3B',
        }}
      >
        {cta.text}{' '}
        <Box ml="0.5rem" display="inline-block">
          <svg
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.2803 11.0306L8.53031 17.7806C8.46066 17.8504 8.37794 17.9057 8.28689 17.9434C8.19584 17.9812 8.09825 18.0006 7.99968 18.0006C7.90112 18.0006 7.80353 17.9812 7.71248 17.9434C7.62143 17.9057 7.53871 17.8504 7.46906 17.7806L0.71906 11.0306C0.578329 10.8899 0.499268 10.699 0.499268 10.5C0.499268 10.301 0.578329 10.1101 0.71906 9.96937C0.85979 9.82864 1.05066 9.74958 1.24968 9.74958C1.44871 9.74958 1.63958 9.82864 1.78031 9.96937L7.24968 15.4397V0.75C7.24968 0.551088 7.3287 0.360322 7.46935 0.21967C7.61001 0.0790178 7.80077 0 7.99968 0C8.1986 0 8.38936 0.0790178 8.53002 0.21967C8.67067 0.360322 8.74968 0.551088 8.74968 0.75V15.4397L14.2191 9.96937C14.3598 9.82864 14.5507 9.74958 14.7497 9.74958C14.9487 9.74958 15.1396 9.82864 15.2803 9.96937C15.421 10.1101 15.5001 10.301 15.5001 10.5C15.5001 10.699 15.421 10.8899 15.2803 11.0306Z"
              fill="#fff"
            />
          </svg>
        </Box>
      </Button>
    )}
  </Box>
);
